import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const SmsLine24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 17.3H14.2958L13.7979 17.7979L12 19.5958L10.2021 17.7979L9.70416 17.3H9H5C4.28203 17.3 3.7 16.718 3.7 16V7C3.7 6.28203 4.28203 5.7 5 5.7H19C19.718 5.7 20.3 6.28203 20.3 7V16C20.3 16.718 19.718 17.3 19 17.3H15ZM11.2929 21.2929L9 19H5C3.34315 19 2 17.6569 2 16V7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7V16C22 17.6569 20.6569 19 19 19H15L12.7071 21.2929C12.3166 21.6834 11.6834 21.6834 11.2929 21.2929ZM7 13C7.82843 13 8.5 12.3284 8.5 11.5C8.5 10.6716 7.82843 10 7 10C6.17157 10 5.5 10.6716 5.5 11.5C5.5 12.3284 6.17157 13 7 13ZM12 13C12.8284 13 13.5 12.3284 13.5 11.5C13.5 10.6716 12.8284 10 12 10C11.1716 10 10.5 10.6716 10.5 11.5C10.5 12.3284 11.1716 13 12 13ZM17 13C17.8284 13 18.5 12.3284 18.5 11.5C18.5 10.6716 17.8284 10 17 10C16.1716 10 15.5 10.6716 15.5 11.5C15.5 12.3284 16.1716 13 17 13Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
